import cookie from '@tencent/vft-common/cookie';
import logger from '@tencent/vft-common/logger';
import { globalObject } from '@tencent/vft-common/system';
import { loadScript } from '@tencent/vft-common/util.esm';

let loadPromise = null;
// wiki: https://mirrors.tencent.com/#/private/npm/detail?repo_id=537&project_name=%40tencent%2Fqimeisdk-web
export class Sign {
  sdk = null;

  async getWebInstance() {
    if (!this.sdk) {
      const QimeiWebLite = await this.loadQimeiSDK();
      this.sdk = new QimeiWebLite({ appKey: '15d45fa36b498329' });
    }
    return this.sdk;
  }

  async loadQimeiSDK() {
    if (!globalObject.QimeiWebLite) {
      // report和login同时调用 getWebInstance的时候会同时load2次script
      loadPromise = loadPromise || loadScript('https://staticfile.qq.com/sec_platform/sdk-web/0.5/lite.js', { timeout: 2500 }).catch(() => {
        loadPromise = null;
      });
      await loadPromise;
    }
    return globalObject.QimeiWebLite;
  }

  async fetchSDKQimei36() {
    try {
      const sdk = await this.getWebInstance();
      return sdk.getLocalQimei36();
    } catch (e) {
      logger.error('getLocalQimei36 error', e);
      return {
        q36: '',
        h38: '',
      };
    }
  }

  /**
   * 获取Qimei36
   * 优先从 cookie 中的字段 vdevice_qimei36 取值，取不到则从 h5-qimei-sdk 取
   * @param {Boolean} useCookie 是否强制从 cookie 取
   * @returns
   */
  async getQimei36(useCookie = false) {
    const qimei36 = cookie.get('vdevice_qimei36') || '';

    if (useCookie) {
      return qimei36;
    }

    if (qimei36) {
      return qimei36;
    }
    const { q36 } = await this.fetchSDKQimei36();
    return q36;
  }

  /**
   * 获取h38
   * @returns {String}
   */
  async getH38() {
    // 获取本地 qimei36, 无需等待网络下发，如未下发则会自动生成临时的 42 位的 h38，和空的 q36
    const { h38 } = await this.fetchSDKQimei36();
    return h38;
  }

  /**
   * 获取签名信息
   * @returns {Object}
   */
  async getSignInfo() {
    // 获取本地 qimei36, 无需等待网络下发，如未下发则会自动生成临时的 42 位的 h38，和空的 q36
    const { q36, h38 } = await this.fetchSDKQimei36();

    // 签名原始信息
    const ts = Date.now();
    const guid = cookie.get('video_guid');
    const signOriginValue = `g=${guid}&t=${ts}&r=${Math.random().toString(36)
      .slice(2)}`;
    let signResult = '';

    try {
      const sdk = await this.getWebInstance();
      signResult = await sdk.sign(signOriginValue, ts);
    } catch (error) {
      logger.error('qimeiWebSdk.sign fail: ', error);
    }

    return {
      q36,
      h38,
      o_data: signOriginValue, // 原始数据 g={guid}&t={时间戳}&r={随机字符串}
      s: signResult, // 加密后的密文
    };
  }
}

export default new Sign();
